export default {
	title: 'Parti interessate',
	context_best: 'Favorevole',
	context_worse: 'Ostile',
	zones: {
		positive: 'Favorevole',
		positive_line2: 'Zona',
		neutral: 'Neutrale',
		negative: 'Ostile',
		negative_line2: 'Zona',
		point_of_view_line1: 'Punto',
		point_of_view_line2: 'di',
		point_of_view_line3: 'vista'
	},
	tabs: {
		general: {
			title: 'Generale'
		},
		links: {
			title: 'Link'
		},
		comments: {
			title: 'Cronologia'
		},
		filters: {
			title: 'Filtri vista'
		},
		export: {
			title: 'Esporta',
			image: 'Esporta radar come immagine'
		},
		risks: {
			title: 'Rischi'
		},
		bot: {
			title: 'IA'
		},
		tags: {
			title: 'Tag',
			assigned: 'Tag assegnati',
			unassigned: 'Tag non assegnati'
		},
		disabled: {
			title: 'Disabilitati'
		}
	},
	summary: {
		key_drivers: 'Fattori chiave',
		scenario_score: 'Punteggio scenario',
		max_value: 'max {{value}}',
		legend: {
			current: 'Attuale',
			scenario: 'Scenario'
		}
	},
	all_tags: 'Filtro tag',
	links: 'Mostra tutti i link',
	no_tag: 'Nessun tag',

	all_icons: 'Filtro icone',
	no_icon: 'Nessuna icona',

	all_stakes: 'Filtro interessi',
	all_constraints: 'Filtro indicatori',
	all_risks: 'Filtro rischi',
	all_opportunities: 'Filtro aperture',

	alignment: {
		title_1: 'Parti interessate',
		title_2: 'allineamento'
	},
	onboarding: {
		title: 'Revisione delle parti interessate',
		description:
			"Gli attori che gravano sul tuo tema sono posizionati sul radar in base alla loro influenza e postura. Verifica l'allineamento e aggiusta se la tua lettura è diversa."
	}
};
